import { typographyV2 } from '@toggle/design-system';
import { PriceStatus } from '@toggle/helpers';
import styled from 'styled-components';

export const ProportionChangeColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const ProportionPrice = styled.span`
  font-family: var(--font-roboto-mono);
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: var(--text-default);
`;

export const ProportionCurrency = styled.span`
  ${typographyV2.bodyXXs}
  color: var(--text-default);
  text-transform: uppercase;
`;

const percentageChangeColors = {
  [PriceStatus.Default]: 'var(--text-soft)',
  [PriceStatus.Negative]: 'var(--viz-bearish)',
  [PriceStatus.Positive]: 'var(--viz-bullish)',
};

export const PercentageChange = styled.span<{ $status: PriceStatus }>`
  font-family: var(--font-roboto-mono);
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${({ $status }) => percentageChangeColors[$status]};
`;

export const DateSpan = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-soft);
`;
